import { render, staticRenderFns } from "./BrandPin.vue?vue&type=template&id=d443b8e0"
import script from "./BrandPin.vue?vue&type=script&lang=js"
export * from "./BrandPin.vue?vue&type=script&lang=js"
import style0 from "./BrandPin.vue?vue&type=style&index=0&id=d443b8e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports